import { StoreOptions, ActionContext } from 'vuex';
import { get, post, ApiResult } from '../helpers/api';

type AuthenticationResult = ApiResult<any>;

export async function signIn(ctx: ActionContext<any,any>, data: { username: string, password: string }) {
    const endpoint = `/_api/v1/auth/signin`;

    let result: AuthenticationResult = await post(endpoint, data)
        .then(res => res.data);

    ctx.commit('updateAuthentication', { result: result.result, user: result.data });

    return result;
}

export async function signOut(ctx: ActionContext<any,any>) {
    const endpoint = `/_api/v1/auth/signout`;

    let result: AuthenticationResult = await post(endpoint)
        .then(res => res.data);

    ctx.commit('updateAuthentication', { result: result.result, user: null });

    return result;
}

export async function authenticationCheck(ctx: ActionContext<any,any>, data: any) {
    const endpoint = `/_api/v1/auth/check`;

    let result: AuthenticationResult = await get(endpoint)
        .then(res => res.data);

    ctx.commit('updateAuthentication', { result: result.result, user: result.data });

    return result;
}

export function passwordSendUpdateEmail(ctx: ActionContext<any,any>, data: { email: string }) {
    const endpoint = `/_api/v1/auth/password/send-update-email`;

    return post(endpoint, data).then(res => res.data);
}

export function passwordUpdate(ctx: ActionContext<any,any>, data: { password: string, code: string, userId: string }) {
    const endpoint = `/_api/v1/auth/password/update`;

    return post(endpoint, data).then(res => res.data);
}


// WEBPACK FOOTER //
// ./src/dndg/access/actions.ts